import styled from 'styled-components'

import { Numeric } from '@blade/ui-kit'
import { Trend } from '@root/entities/trend'
import { TrendIcon, TrendTriangle } from '@root/entities/trend/ui'

import type { ClassNameProps } from '@root/shared/lib/react'

type PairTrendProps = {
  changePercents: number
  showPercents?: boolean
  iconSize?: number
  iconVariant?: 'arrow' | 'triangle'
} & ClassNameProps

export const PairTrend: React.FC<PairTrendProps> = ({
  changePercents,
  showPercents,
  className,
  iconSize = 10,
  iconVariant = 'arrow',
}) => {
  const trend = Trend.of(changePercents)

  return (
    <Root className={className}>
      {showPercents ? (
        <Change data-trend={trend}>
          <Numeric
            value={Math.abs(changePercents)}
            preset="trend-change-percents"
          />
          %
        </Change>
      ) : undefined}
      {iconVariant === 'arrow' ? (
        <TrendIcon size={iconSize} trend={trend} variant="candle" />
      ) : (
        <TrendTriangle trend={trend} size={iconSize} />
      )}
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  align-items: center;
  gap: 2px;

  font-weight: 500;
  font-size: 12px;
`

const Change = styled.div`
  &[data-trend='up'] {
    color: var(--up-9);
  }
  &[data-trend='neutral'] {
    color: var(--text-11);
  }
  &[data-trend='down'] {
    color: var(--down-9);
  }
`
